export default __webpack_public_path__ + "static/slide4-mobile-5ca9942e0c11e14cb73b2b7b59e0dc3f.png";